<form [formGroup]="form" class="container-fluid container-filter mt-n1" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h5 style="display:inline">Código de la U.I.: {{ unidadInspeccion?.CodigoUhc }}</h5>
                <h5 style="display:inline; margin-left: 8px">
                    <span>
                        <img *ngIf="unidadInspeccion?.IdEstadoUi" class="estado-icono-big" container="body" src="{{ unidadInspeccion?.IdEstadoUi | IconoEstadoUnidadInspeccion }}" ngbTooltip="{{ unidadInspeccion?.EstadoUi }}" />
                        <img *ngIf="!unidadInspeccion?.IdEstadoUi" class="estado-icono-big" container="body" src="{{ null | IconoEstadoUnidadInspeccion }}" ngbTooltip="{{ 'Nueva' }}" />
                    </span>
                </h5>
            </div>
        </div>
        <ng-container *ngIf="unidadInspeccion?.FirstRecinto?.PeriodoEnPlazoVigente === false">
            <div class="col-4 nota-info m-1">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Unidad de Inspección en Periodo finalizado</label>
            </div>
        </ng-container> 

        <div class="row">
            <div class="col-md-12">
    
                <div class="row">
    
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Básicos de la U.I.
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
    
                                    <div class="row">
    
                                        <div class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4">
                                            <label class="col-form-label" for="Campania">Campaña</label>
                                            <input formControlName="Campania" name="Campania" readonly class="form-control" id="Campania" type="text" value="" title="{{ form.value.Campania }}">
                                        </div>
    
                                        <div class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4">
                                            <label class="col-form-label" for="Periodo">Periodo</label> <label class="small">(de la "Campaña")</label>
                                            <input formControlName="Periodo" name="Periodo" readonly class="form-control" id="Periodo" type="text" value="" title="{{ form.value.Periodo }}">
                                        </div>

                                        <div class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4">
                                            <label class="col-form-label" for="TipoRecinto">Tipo de Solicitud</label>
                                            <input formControlName="TipoRecinto" name="TipoRecinto" readonly class="form-control" id="TipoRecinto" type="text" value="" title="{{ form.value.TipoRecinto }}">
                                        </div>
        
                                        <div class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4">
                                            <label class="col-form-label" for="DescripcionComunidad">Com. Aut.</label> <label class="small">(del "Periodo")</label>
                                            <input formControlName="DescripcionComunidad" name="DescripcionComunidad" readonly class="form-control" id="DescripcionComunidad" type="text" value="" title="{{ form.value.DescripcionComunidad }}">
                                        </div>
        
                                        <div class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4" *ngIf="form.value.EntidadAuditora">
                                            <label class="col-form-label" for="EntidadAuditora">Ent. Aud.</label> <label class="small">(de la "Comunidad")</label>
                                            <input formControlName="EntidadAuditora" name="EntidadAuditora" readonly class="form-control" id="EntidadAuditora" type="text" value="" title="{{ form.value.EntidadAuditora }}">
                                        </div>

                                        <div *ngIf="!isOperadorCam" class="form-group col-xl-4 col-lg-4 col-md-2 col-sm-4">
                                            <label class="col-form-label" for="Operador">Operador</label> <label class="small">(Razón Social)</label>
                                            <input formControlName="Operador" name="Operador" readonly class="form-control" id="Operador" type="text" value="" title="{{ form.value.Operador }}">
                                        </div>
        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        

    </div>
</form>